import { v4 as uuidv4 } from 'uuid'
import { translate } from '../components/internationalization'

export interface Props {
    topic: string
    stream_guid: string | null
    commit: Function
}

export async function insertStream({
    topic,
    stream_guid,
    commit,
}: Props): Promise<{ __id?: string, errorText?: string }> {
    try {
        const variables = {
            stream_guid: stream_guid || uuidv4(),
            topic,
            last_message: '' // TODO Drop this db field
        }

        // Wrap the commit function in a Promise to handle onCompleted/onError properly
        const result = await new Promise<{ __id?: string, errorText?: string }>((resolve) => {
            commit({
                variables,
                onCompleted(res: any) {
                    resolve({ __id: res?.insert_stream_one?.id })
                },
                onError(err: any) {
                    console.error(err)
                    resolve({ errorText: translate('Failed to send your message, please try again later') })
                },
            })
        })

        return result
    } catch (err) {
        console.error(err)
        return { errorText: translate('Failed to send your message, please try again later') }
    }
}
